import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import { IWorkZoneSearchResult } from '../business-objects/types';

// types
export enum WorkZoneSearchActionTypes {
  SEARCH = 'SEARCH',
  GET_IMAGE = 'GET_IMAGE',
  UPDATE_NDOT_WZ_FLAG = 'UPDATE_NDOT_WZ_FLAG',
  UPDATE = 'UPDATE'
}

export const workZoneSearch = (url: string) => {
  return async dispatch => {
    try {
      Api.get(url).then((result: ApiResponse<any>) => {
        dispatch(reduceResults(result.data.results));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const reduceResults = (result: IWorkZoneSearchResult[]) => {
  return {
    type: WorkZoneSearchActionTypes.SEARCH,
    value: result
  };
};

export const reduceUpdateResults = (result: IWorkZoneSearchResult[]) => {
  return {
    type: WorkZoneSearchActionTypes.UPDATE,
    value: result
  };
};

export const updateNdotWorkZoneIndicator = (url: string) => {
  return async () => {
    try {
      await Api.post(url).then(result => {
        if (result.ok)
          return Promise.resolve();
        else
          console.log(result.originalError);
          return Promise.reject(result.originalError);
      }).catch(ex => {
        console.log(ex);
        return Promise.reject(ex);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const removeReportFromWorkZoneSearch = (url: string) => {
  return async dispatch => {
    try {
      Api.post(url).then((result: ApiResponse<any>) => {
        dispatch(reduceResults(result.data.results));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const addReportToWorkZoneSearch = (url: string) => {
  return async dispatch => {
    try {
      Api.post(url).then((result: ApiResponse<any>) => {
        dispatch(reduceResults(result.data.results));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const reduceNdotWorkZoneIndicatorResults = (result: IWorkZoneSearchResult[]) => {
  return {
    type: WorkZoneSearchActionTypes.UPDATE_NDOT_WZ_FLAG,
    value: result
  };
};
